import styled from "styled-components";
const ExperienceData = styled.div`
  color: white;
  & ::marker {
    color: #64ffda;
  }
  @media only screen and (max-width: 600px) {
      margin-top: 10px;
  }
`;
export default ExperienceData;
